import React from "react";
import TechnicalFiles from "../../lib/Pages/TechnicalFiles";

export default function TechFilesPage() {
  return <TechnicalFiles />;
}
